{{#each this}}
  <div class='card' data-id='{{id}}'>
    <div class='card__thumb'>
      {{#if poster_path}}
        <picture class='card__image'>
          <source
            srcset='https://image.tmdb.org/t/p/w780{{poster_path}}'
            media='(min-width: 1280px)'
          />
          <source
            srcset='https://image.tmdb.org/t/p/w500{{poster_path}}'
            media='(min-width: 768px)'
          />
          <source
            srcset='https://image.tmdb.org/t/p/w342{{poster_path}}'
            media='(min-width: 320px)'
          />

          <img
            data-id='{{id}}'
            src='https://image.tmdb.org/t/p/w342{{poster_path}}'
            alt='{{title}}'
            loading='lazy'
            class='card__image'
            style='object-fit: cover'
          />
        </picture>
      {{else}}
        <img
          data-id='{{id}}'
          src='https://cdn.pixabay.com/photo/2014/03/25/16/27/movie-297135_960_720.png'
          alt='{{title}}'
          loading='lazy'
          class='card__image'
          style='object-fit: cover'
        />
      {{/if}}
      <div class='card__overlay'>
        <p class='card__text' data-id='{{id}}'>{{overview}}</p>
      </div>
    </div>
    <h2 data-id='{{id}}' class='card__title'>{{title}}</h2>
    <div class='card__caption'>
      <span data-id='{{id}}' class='card__info'>
        {{genre_ids}}
        |
        {{release_date}}
      </span>
      <span class='card__rating'>
        {{vote_average}}
      </span>
    </div>
  </div>
{{/each}}